// Categoria legal da rubrica e catalogo de tipos de servico (ADR-0015, epic #265).
//
// A categoria legal diz o que a verba e' perante a lei; o tipo de servico diz
// que servico uma consignacao cobra. O catalogo e' GLOBAL e mora em codigo, nao
// em cadastro por orgao: plano de saude e' plano de saude em todo ente. O que
// muda de ente para ente e' quanto ele ocupa de margem, e isso NAO e' atributo
// do tipo — e' a regra de margem do ente que mapeia tipo -> destino (#271). O
// destino daqui e' so' o padrao, usado quando a regra nao diz nada, e reproduz o
// comportamento de hoje: credito vai para o balde dele, facultativa nao ocupa
// margem.
//
// Puro: sem I/O. Ninguem consome isto ainda; a tabela tipada do vinculo (#268)
// e o mapeamento na regra (#271) sao os primeiros.
import { BUCKETS_MARGEM } from "./margem-bucket.js";
export const CATEGORIA_LEGAL = [
    "provento",
    "desconto_obrigatorio",
    "consignacao_credito",
    "consignacao_facultativa",
    "desconto_nao_consignado",
    "nao_classificada",
];
// Os tres baldes vem de margem-bucket.ts: um destino de balde que divergisse do
// balde de verdade seria margem consumida num lugar e lida em outro.
export const DESTINO_MARGEM = [...BUCKETS_MARGEM, "TOTAL", "NENHUM"];
export const TIPOS_SERVICO = [
    {
        codigo: "saude",
        rotulo: "Plano de saúde",
        categoriaPadrao: "consignacao_facultativa",
        destinoPadrao: "NENHUM",
        prioridadePadrao: 1,
    },
    {
        codigo: "coparticipacao_saude",
        rotulo: "Coparticipação em plano de saúde",
        categoriaPadrao: "consignacao_facultativa",
        destinoPadrao: "NENHUM",
        prioridadePadrao: 2,
    },
    {
        codigo: "odonto",
        rotulo: "Plano odontológico",
        categoriaPadrao: "consignacao_facultativa",
        destinoPadrao: "NENHUM",
        prioridadePadrao: 1,
    },
    {
        codigo: "seguro_vida",
        rotulo: "Seguro de vida",
        categoriaPadrao: "consignacao_facultativa",
        destinoPadrao: "NENHUM",
        prioridadePadrao: 3,
    },
    {
        codigo: "funerario",
        rotulo: "Plano funerário",
        categoriaPadrao: "consignacao_facultativa",
        destinoPadrao: "NENHUM",
        prioridadePadrao: 3,
    },
    {
        codigo: "pensao_voluntaria",
        rotulo: "Pensão alimentícia voluntária",
        categoriaPadrao: "consignacao_facultativa",
        destinoPadrao: "NENHUM",
        prioridadePadrao: 4,
    },
    {
        codigo: "associativa",
        rotulo: "Mensalidade de associação, clube ou cooperativa",
        categoriaPadrao: "consignacao_facultativa",
        destinoPadrao: "NENHUM",
        prioridadePadrao: 5,
    },
    {
        codigo: "sindical",
        rotulo: "Mensalidade sindical voluntária",
        categoriaPadrao: "consignacao_facultativa",
        destinoPadrao: "NENHUM",
        prioridadePadrao: 5,
    },
    {
        codigo: "beneficente",
        rotulo: "Contribuição a entidade beneficente",
        categoriaPadrao: "consignacao_facultativa",
        destinoPadrao: "NENHUM",
        prioridadePadrao: 5,
    },
    {
        codigo: "previdencia_complementar",
        rotulo: "Previdência complementar",
        categoriaPadrao: "consignacao_facultativa",
        destinoPadrao: "NENHUM",
        prioridadePadrao: 6,
    },
    {
        codigo: "convenio_compras",
        rotulo: "Convênio de compras",
        categoriaPadrao: "consignacao_facultativa",
        destinoPadrao: "NENHUM",
        prioridadePadrao: 5,
    },
    {
        codigo: "cooperativa_credito",
        rotulo: "Empréstimo de cooperativa de crédito",
        categoriaPadrao: "consignacao_credito",
        destinoPadrao: "EMPRESTIMO",
        prioridadePadrao: 9,
    },
    {
        codigo: "emprestimo",
        rotulo: "Empréstimo pessoal",
        categoriaPadrao: "consignacao_credito",
        destinoPadrao: "EMPRESTIMO",
        prioridadePadrao: 10,
    },
    {
        codigo: "financiamento",
        rotulo: "Financiamento",
        categoriaPadrao: "consignacao_credito",
        destinoPadrao: "EMPRESTIMO",
        prioridadePadrao: 10,
    },
    {
        codigo: "adiantamento",
        rotulo: "Adiantamento",
        categoriaPadrao: "consignacao_credito",
        destinoPadrao: "EMPRESTIMO",
        prioridadePadrao: 10,
    },
    {
        codigo: "parcelamento",
        rotulo: "Parcelamento",
        categoriaPadrao: "consignacao_credito",
        destinoPadrao: "EMPRESTIMO",
        prioridadePadrao: 10,
    },
    {
        codigo: "cartao_consignado",
        rotulo: "Cartão de crédito consignado",
        categoriaPadrao: "consignacao_credito",
        destinoPadrao: "CARTAO_CONSIGNADO",
        prioridadePadrao: 12,
    },
    {
        codigo: "cartao_beneficio",
        rotulo: "Cartão consignado de benefício",
        categoriaPadrao: "consignacao_credito",
        destinoPadrao: "CARTAO_BENEFICIOS",
        prioridadePadrao: 13,
    },
];
const POR_CODIGO = new Map(TIPOS_SERVICO.map((t) => [t.codigo, t]));
// A entrada e' `string` de proposito: o codigo chega do banco e da API, e
// codigo fora do catalogo e' resposta (`undefined`), nao excecao.
export function tipoServico(codigo) {
    return POR_CODIGO.get(codigo);
}
export function ehTipoServico(codigo) {
    return POR_CODIGO.has(codigo);
}
export function destinoPadrao(codigo) {
    return POR_CODIGO.get(codigo)?.destinoPadrao;
}
export function categoriaDoTipo(codigo) {
    return POR_CODIGO.get(codigo)?.categoriaPadrao;
}
/** So' as duas categorias de consignacao tem credor (e tipo de servico). */
export function ehCategoriaComCredor(categoria) {
    return categoria === "consignacao_credito" || categoria === "consignacao_facultativa";
}
// ===================================== para a tela de classificacao (#270)
/** Rotulo pt-BR da categoria. `Record`: categoria nova sem rotulo nao compila. */
export const ROTULO_CATEGORIA_LEGAL = {
    provento: "Provento",
    desconto_obrigatorio: "Desconto obrigatório",
    consignacao_credito: "Consignação de crédito",
    consignacao_facultativa: "Consignação facultativa",
    desconto_nao_consignado: "Desconto não consignado",
    nao_classificada: "Não classificada",
};
/**
 * O catalogo agrupado como a tela o mostra: credito primeiro (e' o que a
 * averbadora mais classifica), facultativas depois. Derivado de
 * `categoriaPadrao`, entao um tipo novo cai no grupo certo sem ninguem lembrar.
 */
export const GRUPOS_TIPO_SERVICO = [
    {
        categoria: "consignacao_credito",
        rotulo: "Crédito",
        tipos: TIPOS_SERVICO.filter((t) => t.categoriaPadrao === "consignacao_credito"),
    },
    {
        categoria: "consignacao_facultativa",
        rotulo: "Facultativas",
        tipos: TIPOS_SERVICO.filter((t) => t.categoriaPadrao === "consignacao_facultativa"),
    },
];
const EH_BALDE = new Set(BUCKETS_MARGEM);
/**
 * O produto (balde) que um tipo de credito ocupa por padrao, para pre-preencher
 * a classificacao. `null` para facultativa (destino `NENHUM`) e para tipo fora
 * do catalogo: o destino da facultativa e' da regra do ente, nao da rubrica.
 */
export function produtoPadraoDoTipo(codigo) {
    const destino = destinoPadrao(codigo);
    return destino !== undefined && EH_BALDE.has(destino) ? destino : null;
}
/**
 * O tipo que o produto ja' gravado determina sozinho — so' os dois cartoes. O
 * EMPRESTIMO tem cinco tipos (pessoal, cooperativa, financiamento, adiantamento,
 * parcelamento) e nao da' para adivinhar: ai o operador escolhe.
 */
export function tipoSugeridoPeloProduto(produto) {
    if (produto === "CARTAO_CONSIGNADO")
        return "cartao_consignado";
    if (produto === "CARTAO_BENEFICIOS")
        return "cartao_beneficio";
    return null;
}
// ===================================== ponte com NATUREZA_VERBA (ate a #268)
//
// `Record` e nao `switch`: natureza ou categoria nova sem traducao vira erro de
// compilacao, em vez de um `undefined` calado.
const CATEGORIA_DA_NATUREZA = {
    consignacao: "consignacao_credito",
    consignacao_nao_crediticia: "consignacao_facultativa",
    provento: "provento",
    desconto_nao_consignado: "desconto_nao_consignado",
    nao_classificada: "nao_classificada",
};
// `desconto_obrigatorio` nao existe na camada antiga: la ele e' o que o sistema
// sabia dizer antes da ADR-0015 — desconto real fora da margem. Sai junto com
// `NATUREZA_VERBA`, depois da #268.
const NATUREZA_DA_CATEGORIA = {
    provento: "provento",
    desconto_obrigatorio: "desconto_nao_consignado",
    consignacao_credito: "consignacao",
    consignacao_facultativa: "consignacao_nao_crediticia",
    desconto_nao_consignado: "desconto_nao_consignado",
    nao_classificada: "nao_classificada",
};
/** Mapeamento 1:1 da natureza atual para a categoria legal (ADR-0015, ponto 1). */
export function categoriaDaNatureza(natureza) {
    return CATEGORIA_DA_NATUREZA[natureza];
}
/** Inverso, para quem ainda le `NATUREZA_VERBA`. Unico caso nao 1:1: `desconto_obrigatorio`. */
export function naturezaDaCategoria(categoria) {
    return NATUREZA_DA_CATEGORIA[categoria];
}
//# sourceMappingURL=tipo-servico.js.map